<p>
  {{'app-version' | translate}} {{appVersion}}
</p>
